import  { createContext, useContext, useEffect, useState, ReactNode } from 'react';
import { AuthServices } from '../services/AuthServices';
import User  from '../models/User';
import { useNavigate } from 'react-router-dom';
import { set } from 'date-fns';




interface SessionContextType {
  isAuthenticated: boolean;
  token: string | null;
  loggedUser: User | null;
  loadingUserInfo: Boolean;
  login: (token: string) => void;
  logout: () => void;
}

const SessionContext = createContext<SessionContextType | undefined>(undefined);

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error('useSession must be used within a SessionProvider');
  }
  return context;
};

export const SessionProvider = ({ children }: { children: ReactNode }) => {
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [loggedUser, setLoggedUser] = useState<User | null>(null);
  const [loadingUserInfo, setLoadingUserInfo] = useState<Boolean>(false);
  const saved_center_id = localStorage.getItem('active_center_id') || '';
  const navigate = useNavigate()

  useEffect(() => {
    const storedToken = localStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }
  }, []);

  const login = (newToken: string) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setLoggedUser(null);
    navigate('/login');
  };

  useEffect(() => {
    if (token) {
      setLoadingUserInfo(true);
      AuthServices.getUserInformations(token)
        .then((res) => {
          const result = res as { success: boolean; message?: string; data?: any };
          if (result.success === true) {

            setLoggedUser(result.data.user);
          } else {
            setLoggedUser(null);
          }
          setLoadingUserInfo(false);
        })
        .catch(() => {
          setLoggedUser(null);

          setLoadingUserInfo(false);
        });
    } else {
      setLoggedUser(null);
    }
  }, [token]);



  return (
    <SessionContext.Provider value={{
      isAuthenticated: !!token,
      loggedUser,
     loadingUserInfo,
      token,
      login,
      logout,
    }}>
      {children}
    </SessionContext.Provider>
  );
};
